module.exports = __webpack_public_path__ + "media/src/images/icons/flags/netherlands-3bc81ef751af93da97c25ba816a69c5f.svg";